import { useTranslation } from 'react-i18next';
import { TRANSACTION_TYPE, type TRANSACTION_CATEGORY } from '../../History/types';
import { CategoryWrapper, CategoryIconWrapper } from './styles';
import TransactionIcon from './TransactionIcon';

type TransactionCategoryProps = {
  category: TRANSACTION_CATEGORY;
  credit?: boolean;
  label?: string;
};

const TransactionCategory = ({ category, credit, label }: TransactionCategoryProps) => {
  const { t } = useTranslation(['flexflow']);
  const categoryName = t(`transactions.categories.${category}`);
  const categoryLabel =
    label ?? (credit ? t('transactions.categories.refund', { ns: 'flexflow', category: categoryName }) : categoryName);
  const creditOrCategory = credit ? TRANSACTION_TYPE.CREDIT : category;

  return (
    <CategoryWrapper>
      <CategoryIconWrapper category={creditOrCategory}>
        <TransactionIcon category={creditOrCategory} translationKey={categoryName} />
      </CategoryIconWrapper>{' '}
      <div>{categoryLabel}</div>
    </CategoryWrapper>
  );
};

export default TransactionCategory;
